import React from "react";
import ProductPreviewButton from "web/react/components/product-preview-button/product-preview-button";
import { PRODUCT_PREVIEW_OVERLAY_NAME } from "web/react/components/product-preview/product-preview";
import SaveForLaterButton, {
    ButtonType,
    PageSource,
} from "web/react/components/save-for-later-button/save-for-later-button";
import history from "web/script/utils/history";
import styles from "./dual-pill-button.css";

interface DualPillButtonProps {
    isLoggedIn: boolean;
    type?: ButtonType;
    pageSource: PageSource;
    productId: string;
    productImageURL: string;
    productSlug: string;
    linkId: string;
}

export default function DualPillButton({ linkId, ...props }: DualPillButtonProps): JSX.Element {
    function onProductPreviewClick(): void {
        history.pushOverlay(PRODUCT_PREVIEW_OVERLAY_NAME, {
            data: {
                linkId,
            },
        });
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.pill}>
                <ProductPreviewButton onClick={onProductPreviewClick} />
            </div>
            <div className={styles.separator} />
            <div className={styles.pill}>
                <SaveForLaterButton
                    className={styles.saveForLaterButton}
                    linkId={linkId}
                    showPdpSignUp
                    {...props}
                />
            </div>
        </div>
    );
}
